define.alias("shared/errors/api-not-found-error", "media/errors/api-not-found-error");